export default __webpack_public_path__ + "static/media/this-one-on-me.687cc16e.webp";